<template>
  <div class="container mt-4">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4" style="color: #b03a45;">
        <i class="fas fa-list me-2"></i> {{ $t('expenseCategory.title') }}
      </h4>

      <!-- Form -->
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label class="form-label fw-bold text-dark">{{ $t('expenseCategory.categoryName') }}</label>
              <input type="text" class="form-control" v-model="form.category_name" required />
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label class="form-label fw-bold text-dark">{{ $t('expenseCategory.description') }}</label>
              <input type="text" class="form-control" v-model="form.description" />
            </div>
          </div>
        </div>

        <div class="d-flex gap-3 mt-3">
          <button type="submit" class="btn text-white px-4" style="background-color: #b03a45;">
            {{ editingId ? $t('expenseCategory.update') : $t('expenseCategory.add') }}
          </button>
          <button type="button" class="btn btn-secondary px-4" @click="resetForm">{{ $t('expenseCategory.cancel') }}</button>
        </div>
      </form>

      <!-- List -->
      <hr class="my-4" />
      <h5 class="mb-3" style="color: #b03a45;">
        <i class="fas fa-database me-2"></i> {{ $t('expenseCategory.existingCategories') }}
      </h5>

      <div v-if="categories.length" class="table-responsive">
        <table class="table table-bordered align-middle">
          <thead class="table-light">
            <tr>
              <th>{{ $t('expenseCategory.id') }}</th>
              <th>{{ $t('expenseCategory.categoryName') }}</th>
              <th>{{ $t('expenseCategory.description') }}</th>
              <th class="text-center">{{ $t('expenseCategory.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="cat in categories" :key="cat.id">
              <td>{{ cat.id }}</td>
              <td>{{ cat.category_name }}</td>
              <td>{{ cat.description || '-' }}</td>
              <td class="text-center">
                <button class="btn btn-outline-danger btn-sm me-2" @click="loadCategory(cat)">{{ $t('expenseCategory.edit') }}</button>
                <button class="btn btn-outline-secondary btn-sm" @click="deleteCategory(cat.id)">{{ $t('expenseCategory.delete') }}</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p v-else class="text-muted">{{ $t('expenseCategory.noCategories') }}</p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from '@/api' // adapte selon ton alias
import { useToast } from 'vue-toastification'

const toast = useToast()

const categories = ref([])
const editingId = ref(null)

const form = ref({
  category_name: '',
  description: ''
})

const fetchCategories = async () => {
  try {
    const { data } = await axios.get('/Financial/expense-categories') // 
    categories.value = data || []
  } catch (err) {
    toast.error($t('expenseCategory.failedToLoadCategories'))
    console.error(err)
  }
}

const handleSubmit = async () => {
  try {
    if (editingId.value) {
      await axios.put(`/Financial/expense-categories/${editingId.value}`, form.value)
      toast.success($t('expenseCategory.categoryUpdated'))
    } else {
      await axios.post('/Financial/expense-categories', form.value)
      toast.success($t('expenseCategory.categoryAdded'))
    }
    resetForm()
    fetchCategories()
  } catch (err) {
    toast.error($t('expenseCategory.errorSavingCategory'))
    console.error(err)
  }
}

const loadCategory = (cat) => {
  editingId.value = cat.id
  form.value = {
    category_name: cat.category_name,
    description: cat.description
  }
}

const deleteCategory = async (id) => {
  try {
    await axios.delete(`/Financial/expense-categories/${id}`)
    toast.success($t('expenseCategory.categoryDeleted'))
    fetchCategories()
  } catch (err) {
    toast.error($t('expenseCategory.errorDeletingCategory'))
    console.error(err)
  }
}

const resetForm = () => {
  editingId.value = null
  form.value = {
    category_name: '',
    description: ''
  }
}

onMounted(fetchCategories)
</script>
